var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [
              { name: "各種設定" },
              {
                name: "応募者メッセージテンプレート一覧",
                pathName: "settingMessageTemplates",
              },
            ],
            title: "応募者メッセージテンプレート" + _vm.formTypeLabel,
            "data-test": "title",
          },
        }),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            { staticClass: "boss-scout-send-container" },
            [
              _c("form-item", {
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [
                        _c("span", [
                          _vm._v("テンプレート名"),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", [_vm._v("（50文字以内）")]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
              _vm._v(" "),
              _c("form-item", {
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [
                        _c("span", [
                          _vm._v("件名"),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", [_vm._v("（200文字以内）")]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.subject,
                  callback: function ($$v) {
                    _vm.subject = $$v
                  },
                  expression: "subject",
                },
              }),
              _vm._v(" "),
              _c("form-item-text-area", {
                ref: "message",
                attrs: {
                  "class-name": "boss-send-textarea",
                  rows: "",
                  cols: "",
                  "data-test": "message-body",
                },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [
                        _c("span", [
                          _vm._v("本文"),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", [_vm._v("（10000文字以内）")]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "padding-bottom-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "boss-button",
                              attrs: { "data-test": "user-name" },
                              on: {
                                click: function ($event) {
                                  return _vm.insertionValue("■USER_NAME■ 様")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                応募者名を挿入\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "boss-button",
                              attrs: { "data-test": "job-name" },
                              on: {
                                click: function ($event) {
                                  return _vm.insertionValue("■JOB_NAME■")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                求人名を挿入\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "boss-button",
                              attrs: { "data-test": "company-name" },
                              on: {
                                click: function ($event) {
                                  return _vm.insertionValue(
                                    _vm.currentUser.companyUserDisplayName
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                社名を挿入\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.body,
                  callback: function ($$v) {
                    _vm.body = $$v
                  },
                  expression: "body",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "form-button-area",
          [
            _c("form-confirm-button", {
              attrs: {
                "is-disabled": _vm.isConfirmButtonDisabled,
                "submit-label":
                  "この内容でテンプレートを" + _vm.formTypeLabel + "する",
                "data-test": "confirm-button",
              },
              on: { "submit-event": _vm.submit },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }